export default () => ({
  closeDropdown() {
    this.$refs.dropdown.removeAttribute("open");
  },
});
